import { all } from 'redux-saga/effects';
import userSaga from './user/userSaga';
import orgSaga from './organizations/orgSaga';
import subscriptionSaga from './subscription/subscriptionSaga';

export default function* rootSaga() {
  yield all([userSaga(), orgSaga(), subscriptionSaga()]);
}
